import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { CoachDto, CoachRegisterDto, CoachRegistrationCompleteDto, CoachRegistrationInitializeDto, CoachRegistrationResultDto, SimpleCoachRegisterDto } from '../../../application/contracts/dtos/coaches/models';
import type { OtpResultDto, VerifyOtpDto } from '../../../application/contracts/dtos/otp-verification/models';
import type { IdentityUserDto } from '../../../volo/abp/identity/models';

@Injectable({
  providedIn: 'root',
})
export class PublicCoachRegistrationService {
  apiName = 'Default';
  

  completeRegistration = (input: CoachRegistrationCompleteDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CoachRegistrationResultDto>({
      method: 'POST',
      url: '/api/public/coach-registration/complete',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  initializeRegistration = (input: CoachRegistrationInitializeDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtpResultDto>({
      method: 'POST',
      url: '/api/public/coach-registration/initialize',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  isUsernameAvailable = (userName: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'GET',
      url: '/api/public/coach-registration/check-username',
      params: { userName },
    },
    { apiName: this.apiName,...config });
  

  register = (input: CoachRegisterDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CoachDto>({
      method: 'POST',
      url: '/api/public/coach-registration/register',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  simpleRegister = (input: SimpleCoachRegisterDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IdentityUserDto>({
      method: 'POST',
      url: '/api/public/coach-registration/simple-register',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  verifyOtp = (input: VerifyOtpDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtpResultDto>({
      method: 'POST',
      url: '/api/public/coach-registration/verify-otp',
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
